
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";


const systemActionAPI = createApi({
    reducerPath: 'systemActionAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

         //** Add  API */ 
         addEditSystemAction: builder.mutation({
            query: (Details) => ({
                url: '/SystemAction/AddEditSystemAction',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getSystemAction: builder.mutation({
            query: (Details) => ({
                url: '/SystemAction/GetSystemAction',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        DeleteSystemAction: builder.mutation({
            query: (systemActionId) => ({
                url: `/SystemAction/DeleteSystemAction/?systemActionId=${systemActionId}`,
                method: 'DELETE',
                body: transformRequest(systemActionId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
            //**  GetByID API */
            getSystemActionById: builder.query({
                query: (systemActionId) => ({
                    url: encryptQueryString(`/SystemAction/GetSystemActionById/?systemActionId=${Number(systemActionId)}`),
                    method: 'GET',
                }),
     
                transformResponse: transformSucessResponse,
                transformErrorResponse: transformErrorResponse
            }),
         
            getAllSystemActions: builder.query({
                query: () => ({
                    url: `/SystemAction/GetAllSystemActions`,
                    method: 'GET',
                }),
                transformResponse: transformSucessResponse,
                transformErrorResponse: transformErrorResponse
            }),
    }),
})

export const {
    useAddEditSystemActionMutation,
    useGetSystemActionMutation,
    useDeleteSystemActionMutation,
    useLazyGetSystemActionByIdQuery,
    useLazyGetAllSystemActionsQuery
   
} = systemActionAPI;

export default systemActionAPI;